<template>
  <div class="indicators">
    <SectionTitle text="Бюджетная политика" class="indicators__title" />
    <ul class="indicators__list" v-if="!isLoading">
      <template v-for="item in indicatorsList" :key="item.id">
        <li class="indicators__item" v-if="item.count !== '-'">
          <p class="indicators__item-text">{{ item.title }}</p>
          <div v-if="item.source" class="indicators__item-source">Источник: {{ item.source }}</div>
          <div v-if="item.source" class="indicators__item-source">
            <!-- <template v-if="item.id == 5">
            2 кв 2022
          </template>
          <template v-else>
            По данным за 2021 год
          </template> -->
            <template v-if="yearUpdate">
              По данным за {{ yearUpdate }} год
              <template v-if="item.showPeriodDescription">{{ getPeriodDescription(yearUpdate) }}</template>
            </template>
          </div>
          <strong class="indicators__item-number">{{
            isNaN(item.count) ? item.count : formatNumber(Number(item.count))
          }}</strong>
          <!--        <div v-if="item.awards.length" class="award d-flex flex-column">-->
          <!--          <span v-for="(award, idx) in item.awards" :key="idx" class="indicators__item-award"-->
          <!--            >{{ award.count }} место - {{ award.country }}</span-->
          <!--          >-->
          <!--        </div>-->
        </li>
      </template>
    </ul>
  </div>

  <BudgetChart
    :countryId="countryId"
    title="Основные показатели бюджетной политики"
    :titleTooltipContent="tooltipLegendText"
  />
</template>

<script>
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import constants from '@/common/constants';
  import text from '@/common/mixins/text';

  import Api from '../api';
  import getPeriodDescription from '../utils/period';
  import BudgetChart from './BudgetChart.vue';

  export default {
    name: 'Budget',
    components: { BudgetChart, SectionTitle },
    mixins: [text],
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        indicatorsList: [
          {
            id: 1,
            title: 'Баланс бюджета, % ВВП',
            source: 'Международный валютный фонд',
            count: 'Загрузка...',
            awards: [],
            showPeriodDescription: false,
          },
          {
            id: 2,
            title: 'Государственные доходы, % ВВП',
            source: 'Международный валютный фонд',
            count: 'Загрузка...',
            awards: [
              { country: 'Загрузка...', count: '1' },
              { country: 'Россия', count: '0' },
            ],
            showPeriodDescription: true,
          },
          {
            id: 3,
            title: 'Государственные расходы, % ВВП',
            source: 'Всемирный банк',
            count: 'Загрузка...',
            awards: [
              { country: 'Загрузка...', count: '1' },
              { country: 'Россия', count: '0' },
            ],
            showPeriodDescription: false,
          },
          {
            id: 4,
            title: 'Государственный долг, % ВВП',
            source: 'Международный валютный фонд',
            count: 'Загрузка...',
            awards: [
              { country: 'Загрузка...', count: '1' },
              { country: 'Россия', count: '0' },
            ],
            showPeriodDescription: true,
          },
          {
            id: 5,
            title: 'Общий кредит нефинансовому сектору, % ВВП',
            source: 'Банк международных расчетов',
            count: 'Загрузка...',
            awards: [
              { country: 'Загрузка...', count: '1' },
              { country: 'Россия', count: '0' },
            ],
            showPeriodDescription: true,
          },
          {
            id: 6,
            title: 'Золотовалютные резервы, млрд $ США',
            source: 'Всемирный банк',
            count: 'Загрузка...',
            awards: [
              { country: 'Загрузка...', count: '1' },
              { country: 'Россия', count: '0' },
            ],
            showPeriodDescription: false,
          },
          {
            id: 7,
            title: 'Золотовалютные резервы, объем в золоте, млрд $ США',
            source: 'gold.org',
            count: 'Загрузка...',
            awards: [
              { country: 'Загрузка...', count: '1' },
              { country: 'Россия', count: '0' },
            ],
            showPeriodDescription: false,
          },
        ],
        yearUpdate: null,
        isLoading: true,
        tooltipLegendText: constants.tooltipLegendCommon,
      };
    },
    created() {
      this.loadPage();
    },
    methods: {
      getPeriodDescription,
      loadPage() {
        this.isLoading = true;
        Api.getBudgetPolicy(this.countryId)
          .then((response) => {
            this.updateIndicators(response.data);
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error?.response?.data);
            this.isLoading = false;
          });
      },
      updateIndicators(data) {
        this.yearUpdate = data.year;
        const noData = '-';
        let ind = this.indicatorsList.find((x) => x.id === 1);
        ind.count = data.budgetBalance !== null ? data.budgetBalance.toFixed(2) : noData;
        ind = this.indicatorsList.find((x) => x.id === 2);
        ind.count = data.revenue !== null ? data.revenue.toFixed(2) : noData;
        ind = this.indicatorsList.find((x) => x.id === 3);
        ind.count = data.expenses !== null ? data.expenses.toFixed(2) : noData;
        ind = this.indicatorsList.find((x) => x.id === 4);
        ind.count = data.governmentDebt !== null ? data.governmentDebt.toFixed(2) : noData;
        ind = this.indicatorsList.find((x) => x.id === 5);
        ind.count = data.nonFinancialCredit !== null ? data.nonFinancialCredit.toFixed(2) : noData;
        ind = this.indicatorsList.find((x) => x.id === 6);
        ind.count = data.reserves !== null ? (data.reserves / 1000000000).toFixed(2) : noData;
        ind = this.indicatorsList.find((x) => x.id === 7);
        ind.count = data.reservesInGold !== null ? data.reservesInGold.toFixed(2) : noData;
      },
    },
    watch: {
      countryId: function () {
        this.loadPage();
      },
    },
  };
</script>

<style scoped lang="scss">
  .indicators {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__list {
      padding: 0 16px;
      display: flex;
      flex-wrap: wrap;
      gap: 16px 12px;

      @media (max-width: 892px) {
        justify-content: space-between;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 180px;
      width: 100%;
      padding: 15px;
      background: $white;
      box-shadow: 0 0 17px rgba(55, 55, 55, 0.08);
      border: 1px solid $blue-8;
      border-radius: 5px;

      @media (max-width: 1042px) {
        max-width: calc((100% / 4) - 18px);
      }
      @media (max-width: 892px) {
        max-width: calc((100% / 3) - 18px);
      }
      @media (max-width: 546px) {
        max-width: calc((100% / 2) - 18px);
      }
      @media (max-width: 546px) {
        max-width: 100%;
      }

      &-text {
        font: $fira-12;
        line-height: 113.9%;
        text-align: center;
        color: $black;
      }

      &-number {
        margin-top: auto;
        margin-bottom: 9px;
        font: $fira-18-B;
        line-height: 22px;
        text-align: center;
        color: $black;
      }

      &-source {
        text-align: center;
        font: $fira-10-16;
        color: $gray-silver-dark;
      }

      &-award {
        margin-bottom: 4px;
        font: $fira-10-16;
        line-height: 12px;
        text-align: center;
        color: $black;
      }
    }
  }
</style>
